import { render, staticRenderFns } from "./AddLevel.vue?vue&type=template&id=975947ca&scoped=true"
import script from "./AddLevel.vue?vue&type=script&lang=js"
export * from "./AddLevel.vue?vue&type=script&lang=js"
import style0 from "./AddLevel.vue?vue&type=style&index=0&id=975947ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975947ca",
  null
  
)

export default component.exports